import { motion } from "framer-motion";
import { Seo } from "@/components/Seo";
import { MaskedLines, EASE } from "@/components/Motion";
import { CtaLink } from "@/components/CtaLink";
import { HeroComposition } from "@/components/HeroComposition";
import { Marquee } from "@/components/Marquee";
import { ServicesBento } from "@/components/home/ServicesBento";
import { SelectedWork } from "@/components/home/SelectedWork";
import { WhyDesign } from "@/components/home/WhyDesign";
import { Intro } from "@/components/home/Intro";
import { ProcessSteps } from "@/components/ProcessSteps";
import { CtaBanner } from "@/components/CtaBanner";

const Hero = () => (
  <section className="relative overflow-hidden" data-testid="home-hero">
    <div className="mx-auto grid max-w-[1600px] lg:min-h-[calc(100svh-5rem)] lg:grid-cols-12">
      <div className="flex flex-col justify-center px-[var(--gutter)] pb-14 pt-12 lg:col-span-7 lg:py-16 xl:pl-[max(var(--gutter),calc((100vw-1440px)/2+3rem))]">
        <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: EASE }} className="eyebrow flex items-center gap-3 text-royal">
          <span className="h-2 w-2 rounded-full bg-lime ring-1 ring-navy/30" aria-hidden="true" /> Creative design studio · United Kingdom
        </motion.p>
        <MaskedLines
          as="h1"
          onMount
          className="mt-8 font-display text-[2.7rem] font-extrabold leading-[0.98] tracking-[-0.05em] text-navy sm:text-6xl lg:text-[4.6rem] xl:text-[5.6rem]"
          lines={[
            { content: "Design That" },
            { content: "Builds Brands.", className: "text-royal" },
            { content: "Ideas That" },
            { content: <><span className="lime-mark">Move</span> Businesses.</> },
          ]}
        />
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: EASE, delay: 0.7 }} className="mt-8 max-w-xl text-base leading-relaxed text-slatey sm:text-lg">
          PRPO LTD creates distinctive visual identities, compelling brand experiences, and thoughtful digital designs that help businesses stand out and connect with their audiences.
        </motion.p>
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: EASE, delay: 0.85 }} className="mt-10 flex flex-wrap gap-3">
          <CtaLink to="/contact" variant="royal" testid="hero-start-project-button">Start a Project</CtaLink>
          <CtaLink to="/portfolio" variant="ghost" testid="hero-explore-work-button">Explore Our Work</CtaLink>
        </motion.div>
      </div>
      <div className="grain relative bg-royal lg:col-span-5 lg:rounded-bl-[3rem]">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(200,255,61,0.18),transparent_45%)]" aria-hidden="true" />
        <HeroComposition />
      </div>
    </div>
  </section>
);

export default function Home() {
  return (
    <>
      <Seo
        title="PRPO LTD | Graphic Design, Branding & Digital Design Services UK"
        description="PRPO LTD is a UK creative design company offering graphic design, logo design, brand identity, packaging, brochure, website and UI design services."
        path="/"
      />
      <Hero />
      <Marquee />
      <Intro />
      <ServicesBento />
      <SelectedWork />
      <WhyDesign />
      <ProcessSteps />
      <CtaBanner />
    </>
  );
}
